import Joi from 'joi';

// Schemas
export const contentTranslationSchema = Joi.object({
  id: Joi.string().required(),
  version: Joi.number().required(),
  contentId: Joi.string().required(),
  localeId: Joi.string().required(),
  status: Joi.string().required(),
  data: Joi.object().required(),
  creationTimestamp: Joi.number().required(),
});

export const contentSchema = Joi.object({
  id: Joi.string().required(),
  version: Joi.number().required(),
  contentTypeId: Joi.string().required(),
  name: Joi.string().required(),
  status: Joi.string().required(),
  translations: Joi.array().items(contentTranslationSchema).required(),
  creationTimestamp: Joi.number().required(),
});

export const contentTranslationDataVersionSchema = Joi.object({
  timestamp: Joi.number().required(),
  data: Joi.alternatives().try(
    contentTranslationSchema,
    Joi.object().empty(),
  ).required(),
});

export const contentTypeSchema = Joi.object({
  id: Joi.string().required(),
  schema: Joi.object().required(),
});

export const localeSchema = Joi.object({
  id: Joi.string().required(),
});

export const mediaSchema = Joi.object({
  id: Joi.string().required(),
  version: Joi.number().required(),
  name: Joi.string().required(),
  folderId: Joi.string().required(),
  url: Joi.string().required(),
  description: Joi.array().items(
    Joi.object({
      localeId: Joi.string().required(),
      content: Joi.string().allow('').required(),
    }),
  ).required(),
  credit: Joi.string().allow('').required(),
  type: Joi.string().required(),
  size: Joi.number().required(),
  creationTimestamp: Joi.number().required(),
});

export const mediaFolderSchema = Joi.object({
  id: Joi.string().required(),
  name: Joi.string().required(),
  folderId: Joi.string().required(),
  creationTimestamp: Joi.number().required(),
  mediaFolders: Joi.array().items(Joi.object()).required(),
});

export const mediaTreeSchema = Joi.object({
  id: Joi.string().required(),
  version: Joi.number().required(),
  mediaFolders: Joi.array().items(mediaFolderSchema).required(),
});

export const paginationSchema = Joi.object({
  recordsCount: Joi.number().required(),
  pagesCount: Joi.number().required(),
  currentPage: Joi.number().required(),
  previousPage: Joi.number().required().allow(null),
  nextPage: Joi.number().required().allow(null),
});
